var exports = {
  "CB": "RoleManagement.module__roleIndicator___VmFldk",
  "KG": "RoleManagement.module__roleBadge___VmFldk",
  "Gy": "RoleManagement.module__roleRemoveButtonContainer___VmFldk",
  "j1": "RoleManagement.module__roleRemoveButton___VmFldk",
  "r4": "RoleManagement.module__roleRemoveIconContainer___VmFldk",
  "S3": "RoleManagement.module__roleName___VmFldk",
  "MR": "RoleManagement.module__roleListContainer___VmFldk",
  "ek": "RoleManagement.module__assignRoleButton___VmFldk",
  "JO": "RoleManagement.module__assignRoleButtonIcon___VmFldk",
  "RK": "RoleManagement.module__iconSize___VmFldk",
  "Xk": "RoleManagement.module__noRolesLink___VmFldk",
  "X9": "RoleManagement.module__roleColorIndicator___VmFldk",
};

module.exports = exports;
